import React, { useState, useEffect, Children } from "react";
import { AxiosInstance } from "../../../common/Loader/axios.config";
import Select from "react-select";
import Swal from "sweetalert2";
import { IoClose } from "react-icons/io5";

const EditParentModal = ({ isOpen, onClose, selectedParent }) => {
  const [formData, setFormData] = useState({
    title: selectedParent.title,
    description: selectedParent.description,
    price: selectedParent.price,
    category: selectedParent.category,
    children: selectedParent.children,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [allVideos, setAllVideos] = useState([]);

  useEffect(() => {
    async function fetchAllVideos() {
      try {
        const fetchedContent = await AxiosInstance.get("/content-videos");
        setAllVideos(fetchedContent.data.message);
      } catch (error) {
        console.error("Error fetching content:", error);
      }
    }

    fetchAllVideos();
  }, []);

  const options = allVideos.map((video) => ({
    value: video._id,
    label: video.title,
  }));

  const [selectedVideos, setSelectedVideos] = useState<string[]>([]);

const handleVideoChange = (selectedOptions) => {
  if (Array.isArray(selectedOptions)) {
    const selectedIds = selectedOptions.map(option => option.value);
    setSelectedVideos(selectedIds);
    setFormData({ ...formData, children: selectedIds }); 
    console.log("Selected Video IDs", selectedIds);
  } else if (selectedOptions) {
    setSelectedVideos([selectedOptions.value]);
    setFormData({ ...formData, children: [selectedOptions.value] }); 
    console.log("Selected Video ID", selectedOptions.value);
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a JSON object from formData
    const jsonData = JSON.stringify(formData);

    console.log("Form Data:", jsonData);

    setLoading(true);

    AxiosInstance.put(`/${selectedParent._id}/new-content`, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("Content Update Response", response);
        if (response.data.status === "success") {
          const contentId = response.data.message._id;
          Swal.fire({
            icon: "success",
            title: "Content Updated successfully! ",
            text: `${selectedParent.title} has been updated successfully!`,
            showConfirmButton: false,
            timer: 2000,
          });
          onClose();
          setLoading(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: "An error occurred while uploading.",
        });
        setLoading(false);
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-1/2 rounded-lg bg-brand-background p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-2xl text-white"
        >
          <IoClose />
        </button>
        <h2 className="mb-4 text-lg font-semibold text-white">Edit Content</h2>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 text-black"
        >
          <div>
            <label className="mb-2 block text-white">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Price</label>
            <input
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
              required
            />
          </div>

          <div className="text-black">
            <p className="mb-2 block text-white">Children</p>
            <Select
              isMulti
              value={selectedVideos.map((id) => options.find((option) => option.value === id))}
              onChange={handleVideoChange}
              options={options}
              placeholder="Select Video..."
            />
          </div>

          <div>
            <label className="mb-2 block text-white">Category</label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-black"
              required
            >
              <option value="">Select Category...</option>
              <option value="tv">TV</option>
              <option value="vod">Video</option>
              <option value="event">Event</option>
              <option value="shorts">Shorts</option>
              <option value="series">Series</option>
            </select>
          </div>
          <div className="col-span-2">
            <button
              type="submit"
              className="rounded bg-primary px-4 py-2 text-white"
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditParentModal;
